export default __webpack_public_path__ + "static/saibamais-5b84fc495bbb75e00d5071d35a1980ca.svg";